/**
 * Meliusly header behavior — desktop dropdowns (hover + click), mobile
 * drawer with accordion submenus. Mirrors MeliuslyNav.tsx from the
 * headless storefront.
 */
(function () {
  var nav = document.querySelector('[data-mel-nav]');
  if (!nav) return;

  var triggers = Array.prototype.slice.call(nav.querySelectorAll('[data-mel-dropdown-trigger]'));
  var openId = null;

  function setDropdown(id, open) {
    var panel = document.getElementById(id);
    var trigger = nav.querySelector('[data-mel-dropdown-trigger="' + id + '"]');
    if (!panel || !trigger) return;
    var label = trigger.querySelector('[data-mel-dropdown-label]');
    var chevron = trigger.querySelector('[data-mel-dropdown-chevron]');
    var path = chevron ? chevron.querySelector('path') : null;
    var button = trigger.querySelector('button');
    if (open) {
      panel.hidden = false;
      panel.classList.remove('hidden');
      panel.classList.add('lg:block');
      if (label) { label.classList.remove('text-[#161F2B]'); label.classList.add('text-[#0268A0]'); }
      if (chevron) chevron.classList.add('rotate-180');
      if (path) path.setAttribute('stroke', '#0268A0');
      if (button) button.setAttribute('aria-expanded', 'true');
    } else {
      panel.hidden = true;
      panel.classList.add('hidden');
      panel.classList.remove('lg:block');
      if (label) { label.classList.add('text-[#161F2B]'); label.classList.remove('text-[#0268A0]'); }
      if (chevron) chevron.classList.remove('rotate-180');
      if (path) path.setAttribute('stroke', '#161F2B');
      if (button) button.setAttribute('aria-expanded', 'false');
    }
  }

  function closeAll() {
    if (openId) setDropdown(openId, false);
    openId = null;
  }

  triggers.forEach(function (trigger) {
    var id = trigger.getAttribute('data-mel-dropdown-trigger');
    trigger.addEventListener('mouseenter', function () {
      if (openId && openId !== id) setDropdown(openId, false);
      openId = id;
      setDropdown(id, true);
    });
    var button = trigger.querySelector('button');
    if (button) {
      button.addEventListener('click', function () {
        if (openId === id) { closeAll(); } else { closeAll(); openId = id; setDropdown(id, true); }
      });
    }
  });

  Array.prototype.slice.call(nav.querySelectorAll('[data-mel-dropdown]')).forEach(function (panel) {
    panel.addEventListener('mouseleave', function () {
      if (openId === panel.id) closeAll();
    });
  });

  // Close when the pointer leaves the whole nav (trigger row + panel)
  nav.addEventListener('mouseleave', function () {
    closeAll();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  // --- Mobile drawer ---
  var overlay = document.querySelector('[data-mel-menu-overlay]');
  var drawer = document.querySelector('[data-mel-menu-drawer]');

  function setMenu(open) {
    if (!overlay || !drawer) return;
    if (open) {
      overlay.classList.remove('pointer-events-none', 'opacity-0');
      overlay.classList.add('opacity-100');
      drawer.classList.remove('pointer-events-none', '-translate-x-full');
      drawer.classList.add('translate-x-0');
      document.body.style.overflow = 'hidden';
    } else {
      overlay.classList.add('pointer-events-none', 'opacity-0');
      overlay.classList.remove('opacity-100');
      drawer.classList.add('pointer-events-none', '-translate-x-full');
      drawer.classList.remove('translate-x-0');
      document.body.style.overflow = '';
    }
  }

  Array.prototype.slice.call(document.querySelectorAll('[data-mel-menu-open]')).forEach(function (el) {
    el.addEventListener('click', function () { setMenu(true); });
  });
  Array.prototype.slice.call(document.querySelectorAll('[data-mel-menu-close]')).forEach(function (el) {
    el.addEventListener('click', function () { setMenu(false); });
  });
  if (overlay) overlay.addEventListener('click', function () { setMenu(false); });
  if (drawer) {
    Array.prototype.slice.call(drawer.querySelectorAll('a')).forEach(function (a) {
      a.addEventListener('click', function () { setMenu(false); });
    });
  }

  // --- Mobile accordion submenus ---
  var openSub = null;
  function setSub(id, open) {
    var panel = document.getElementById(id);
    var trigger = document.querySelector('[data-mel-submenu-trigger="' + id + '"]');
    if (!panel) return;
    var chevron = trigger ? trigger.querySelector('[data-mel-submenu-chevron]') : null;
    if (open) {
      panel.classList.remove('max-h-0', 'opacity-0');
      panel.classList.add('max-h-[800px]', 'opacity-100');
      if (chevron) chevron.classList.add('rotate-90');
    } else {
      panel.classList.add('max-h-0', 'opacity-0');
      panel.classList.remove('max-h-[800px]', 'opacity-100');
      if (chevron) chevron.classList.remove('rotate-90');
    }
  }
  Array.prototype.slice.call(document.querySelectorAll('[data-mel-submenu-trigger]')).forEach(function (trigger) {
    var id = trigger.getAttribute('data-mel-submenu-trigger');
    trigger.addEventListener('click', function () {
      if (openSub === id) { setSub(id, false); openSub = null; }
      else { if (openSub) setSub(openSub, false); openSub = id; setSub(id, true); }
    });
  });
})();
